define(
  'app/factories/interest_tracker_factory',['app/setup', 'app/views/interest_tracker'],
  function(takhfifan, interestTracker) {
    //factory method
    var removeUrl = '/ajax/pushnotification/remove',
        addUrl = '/ajax/pushnotification/new',
        $interestItems = $('.thk-interest-tracker');

    if ($interestItems.length > 0) {
      $interestItems.each(function () {
        new takhfifan.InterestNotifier({
          el: $(this),
          removeUrl: removeUrl,
          addUrl: addUrl
        });
      });
    }

    if($.cookie('tkh-i-remove')){
      var itemData = $.cookie('tkh-i-remove').split('___');
      if($.cookie('tkh-i-'+itemData[0])){
        $.ajax({
          url: removeUrl,
          data: {
            player_id: itemData[2],
            type: itemData[1],
            value: itemData[0]
          },
          success: function () {
            $.removeCookie('tkh-i-'+itemData[0], {path:'/'});
            $.removeCookie('tkh-i-remove', {path:'/'});
          }
        });
      }
    }
  });

